import { request } from './client.js';

export interface AdminPromotionDto {
  readonly id: string;
  readonly code: string;
  readonly name: string;
  readonly discountPercent: number;
  readonly fixedDiscountMinorUnits: number | null;
  readonly targetEmail: string | null;
  readonly firstPurchaseOnly: boolean;
  readonly maxRedemptions: number | null;
  readonly maxPerUser: number | null;
  readonly startsAt: string;
  readonly endsAt: string | null;
  readonly active: boolean;
  readonly note: string | null;
  readonly createdAt: string;
  readonly stats: {
    readonly reserved: number;
    readonly redeemed: number;
    readonly released: number;
    readonly revenueMinorUnits: number;
    readonly discountMinorUnits: number;
  };
  readonly uses: readonly {
    readonly id: string;
    readonly status: 'reserved' | 'redeemed' | 'released';
    readonly createdAt: string;
    readonly redeemedAt: string | null;
    readonly user: { readonly id: string; readonly email: string; readonly name: string };
    readonly book: {
      readonly id: string;
      readonly title: string;
      readonly plan: 'book' | 'live_book' | 'gift_book';
    };
    readonly payment: {
      readonly id: string;
      readonly status: 'pending' | 'succeeded' | 'canceled';
      readonly listAmountMinorUnits: number;
      readonly discountAmountMinorUnits: number;
      readonly amountMinorUnits: number;
      readonly appliedAt: string | null;
    };
  }[];
}

export interface CreateAdminPromotionInput {
  readonly code: string;
  readonly name: string;
  readonly discountPercent: number;
  readonly fixedDiscountMinorUnits: number | null;
  readonly targetEmail: string | null;
  readonly firstPurchaseOnly: boolean;
  readonly maxRedemptions: number | null;
  readonly maxPerUser: number | null;
  readonly startsAt: string;
  readonly endsAt: string | null;
  readonly active: boolean;
  readonly note: string | null;
}

export const adminPromotionsApi = {
  list: () => request<{ items: readonly AdminPromotionDto[] }>('/admin/promotions'),
  create: (body: CreateAdminPromotionInput) =>
    request<AdminPromotionDto>('/admin/promotions', { method: 'POST', body }),
  setActive: (id: string, active: boolean) =>
    request<AdminPromotionDto>(`/admin/promotions/${id}`, {
      method: 'PATCH',
      body: { active },
    }),
};
